module.exports = __webpack_public_path__ + "static/media/female_artwork.28b8519b.svg";